<template>
    <div>

     <b-modal id="deleteuserconfirm" size="md" ref="deleteuserconfirm" centered :hide-footer="true" :hide-header="true">
         <div class="text-center">
         <!-- <h1 class="m-0" style="font-size: 60px;"><b style="color: #7BBC9A; font-size: 80px;">I</b>kolilu</h1> -->
         <h2 class="mb-0 bg-light ">Delete Action</h2>
       </div>
       <h6>This Action will remove {{ selecteduser }} from the Platform. Continue? </h6>
       <div>
        </div>
        <span class="animated fadeIn">
            <button type="button" class="btn btn-success" :disabled="loading" style="border-radius: 25px;" @click="DeleteUsers()">
              Yes
            </button>
          </span>
           <span class="animated fadeIn">
            <button type="button" class="btn btn-primary" :disabled="loading" style="border-radius: 25px;" @click="CancelDelete()">
              <i class="fa fa-spin fa-spinner"></i>
              No
            </button>
          </span>
     </b-modal>    
       
    <b-modal id="newuserform" size="md" ref="newuserform" centered :hide-footer="true" :hide-header="true">
      <!-- <div class="container d-flex justify-content-center align-items-center p-0">
      <div class="card my-4 shadow p-1 bg-white rounded" style="width: 40rem;">-->
      <div class="text-center">
        <!-- <h1 class="m-0" style="font-size: 60px;"><b style="color: #7BBC9A; font-size: 80px;">I</b>kolilu</h1> -->
        <h2 class="mb-0 bg-light ">{{ formstatus }}</h2>
      </div>
      <div class="card-body">
        <form @submit.prevent="createNewusers()">
          <div class="form-group text-left">
            <label>Full Name</label>
            <input
              v-model="users.sz_fullname"
              type="text"
              class="form-control"
              placeholder="Name"
              required
            />
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group text-left">
                <label>Phone Number</label>
                <input
                  v-model="users.sz_phonenumber"
                  type="tel"
                  class="form-control"
                  placeholder
                  required
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group text-left">
                <label for>Contact Email</label>
                <input
                  v-model="users.sz_emailadress"
                  name="role"
                  type="email"
                  aria-describedby="emailHelp"
                  class="form-control"
                  required
                />
              </div>
            </div>
          </div>
           <div class="row">
            <div class="col">
              <div class="form-group text-left">
                <label>Password</label>
                <input
                  v-model="users.sz_password"
                  type="password"
                  class="form-control"
                  placeholder
                  required
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group text-left">
                <label for>Comfirm Password</label>
                <input
                  v-model="users.sz_cpassword"
                  name="role"
                  type="password"
                  aria-describedby="emailHelp"
                  class="form-control"
                  required
                />
              </div>
            </div>
          </div>
         
         
          <div class="form-group text-left">
            <label for>Profile</label>
            <div class="row">
              <div class="col">
                <select name="profile" id="profile" class="form-control" v-model="users.sz_profile">
                  <option></option>
                  <option value="Administrator" >Administrator</option>
                  <option value="Field Agent">Field Agent</option>
                </select>
              </div>
              <!-- <label for>Status</label> -->
              <div class="col">
                
                <select name="accstatus" id="accstatus" class="form-control" v-model="users.sz_status">
                  <option></option>
                  <option value="Active" >Active</option>
                  <option value="InActive">InActive</option>
                </select>
              </div>
             <!-- <div class="col"> 
                <input
                    type="checkbox"
                    v-model="users.sz_authreq"
                    true-value="Yes"
                        false-value="No"
                        hidden="true"
                    >
              </div>-->
            </div>
          </div>
          
          <p>
            <small class="text-muted">
              By clicking "Save User", you agree to the iKolilu Providers Portal
              <a
                href="#"
              >Terms and Conditions</a> and
              <a href="#">Privacy Policy for User Account Management</a>.
            </small>
          </p>
          <span class="animated fadeIn">
            <button type="submit" class="btn btn-outline-primary" :disabled="loading" style="border-radius: 25px;">
              <i v-if="loading" class="fa fa-spin fa-spinner"></i>
              <template v-else>{{ btnaction }}</template>
            </button>
          </span>
        </form>
      </div>
      <!-- </div>
      </div>-->
    </b-modal>
         <div class="h2"> Manage Users
     
           </div>
           <div class="row">
            <div class="col py-4 text-right px-4 mx-2">
                
                <button class="btn btn-primary" v-b-modal="'newuserform'" style="border-radius: 25px;" @click="AddNewUser()"><i class="fa fa-user-plus" aria-hidden="true"></i> Add Users</button>
            </div>
            </div>
            <div class="card">
            <div class="card-header bg-lighter p-2">
                <div class="row m-0 align-items-center">
                    <div class="col-md-2 px-4"><h6> Users <span class="badge badge-primary"  style="font-size: 12px">{{this.tabdata.length}}</span></h6></div>
                    <div class="col-md-6 w-100">
                        <input type="text" class="form-control w-100"  v-model="search" style="border-radius: 25px; width:100%" placeholder="Search Users Here ...">
                    </div>
                    <div class="col=md-4 text-right px-3">
                        <!-- <base-dropdown tag="li" no-caret=true  position='right'> -->
                            <button class="btn btn-outline-info" style="border-radius: 25px; font-size: 12px" slot="title" hidden>
                            Export PDF
                            <!-- <i class="fas fa-angle-down" style="padding: 3px;"></i> -->
                        </button>
                        <button class="btn btn-outline-info" style="border-radius: 25px; font-size: 12px" slot="title" hidden>
                           Export Excel
                            <!-- <i class="fas fa-angle-down" style="padding: 3px;"></i> -->
                        </button>
                            <!-- <a class="dropdown-item" href="#"><i class="fa fa-file-pdf" style="padding: 3px;"></i>PDF</a>
                            <a class="dropdown-item" href="#"><i class="fa fa-file-excel" style="padding: 3px;"></i>Excel</a>
                        </base-dropdown> -->
                        </div> 
                </div>
            </div>
            <div class="card-body py-0 px-3" style="overflow-y: scroll; height:80vh;">
                 <table
      class="table align-items-center table-flush">
      <thead slot="columns" class="default-color-dark  z-depth-2 text-white text-center">
        <th style="width: 1%"></th>
        <th >User Email</th>
        <th >Full Name</th>
        <th >Phone Number</th>
        <th>Profile</th>
        <th >Status</th>
        <th ></th>
        <th ></th>
      </thead>

      <tbody v-for="(row, i) in theData" :key="i" >
        <td>
          <div style="height: 50px; width: 4px;" :class="`bg-${(row.szcstatus === null) ? 'danger' : (row.szcstatus === 'Pending') ? 'warning' : 'success'}`"></div>
        </td>
         <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szuserid }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
         <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szusername }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szphonenumber }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szprofile }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>

         <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{ row.szacct_stat }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="media align-items-center">
            <span>
              <i class="fa fa-pencil-square-o page-link" v-b-modal="'newuserform'" @click="EditUsers(row)" aria-hidden="false"></i>
            </span>
            </div>
        </td>
        <td>
          <div class="media align-items-center">
            <span>
              <i class="fa fa-times page-link"  v-b-modal="'deleteuserconfirm'"  aria-hidden="true"></i>
            </span>
          </div>
        </td>
        
      </tbody>
    </table>
    <div class="text-center mt-2" v-if="loading">
                <i  style="font-size:80px" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            </div> 
            <p v-if="tabdata.length === 0 && !loading" class="text-muted text-center lead font-weight-bold mt-2">
                Please no data in selected school
              </p>
              <div class="d-flex justify-content-center">
          <!--Pagination -->
                        <nav class="my-4 pt-2">
                                                        <ul class="pagination pagination-circle pg-blue mb-0">
                                <!--Arrow left-->
                                <li class="page-item " :class="{'disabled': (currPage === 1)}" 
            @click.prevent="setPage(currPage-1)">
                                    <a class="page-link" aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span class="sr-only">Previous</span>
                                        </a>
                                </li>
                                <!--Numbers-->
                                <li class="page-item" v-for="(n,i) in totalPage" :key="i" :class="{'active': (currPage === (n))}" 
            @click.prevent="setPage(n)"><a class="page-link">{{n}}</a></li>
                                <!--Arrow right-->
                                <li class="page-item" :class="{'disabled': (currPage === totalPage)}" 
            @click.prevent="setPage(currPage+1)">
                                    <a class="page-link" aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span class="sr-only">Next</span>
                                        </a>
                                </li>
                            </ul> 
                        </nav>
                        <!--/Pagination -->
          </div>

            </div>
            </div>
        </div>
    </div>
</template>
<script>
import http from "@/network/Base.js";
import { mapState } from "vuex";
// import Badge from '@/components/Badge.vue';
// import BaseDropdown from '@/components/BaseDropdown.vue';

export default {
 /* components:{
    Badge,
    // "base-dropdown":BaseDropdown
  },*/
    data(){
        return{

          loading: false,
          tabdata:[],
          btnaction: "",
          selecteduser:"",
          selecteduserid:"",
          formstatus:"",
          search:"", //users.sz_providerid = this.providerid
          users: {
                sz_accid:"",
                sz_emailadress: "",
                sz_fullname: "",
                sz_phonenumber: "",
                sz_password: "",
                sz_cpassword: "",
                sz_profile: "",
                sz_providerid: "",
                sz_authreq:"",
                sz_status:""
            },
            countOfPage: 10,
           currPage: 1,
       filter_name: '',
             details:[  
            ]
        }
    },
    filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
    methods:{
      ssetPage(idx) {
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },
    removeComplaint(i) {
      this.search = "";
    },
    
    CancelDelete(){
        this.$bvModal.hide("deleteuserconfirm");
    },
    AddNewUser()
    {

        this.btnaction = "Save"
        this.formstatus = "Create New Account";
         this.users.sz_emailadress = ""
        this.users.sz_fullname     = ""
        this.users.sz_phonenumber  = ""
        this.users.sz_password     = ""
        this.users.sz_cpassword    = ""
        this.users.sz_profile      = ""
        this.users.sz_authreq      = ""
        this.selecteduserid =  null;
        // this.$bvModal.show("newuserform");
        // let element = this.$refs.newuserform.$el
         //$(element).modal('show')
        // this.users.sz_providerid = row.sz_providerid
        
    },
    EditUsers(row)
    {
        this.formstatus = "Update "+ row.szusername +" Account";
        //row = this.tabdata[i]
        // console.log(row);
        // this.users.sz_emailadress = row[i].sz_emailadress
        this.users.id = row.id
        this.users.sz_emailadress = row.szuserid
        this.users.sz_fullname    = row.szusername
        this.users.sz_phonenumber = row.szphonenumber
        this.users.sz_password    = row.szpassword
        this.users.sz_cpassword   = row.szpassword
        this.users.sz_profile     = row.szprofile
        this.users.sz_providerid  = row.sz_providerid
        this.users.sz_authreq     = row.sz_authreq
        this.users.sz_status      = row.szacct_stat
        this.btnaction            = "Update"
        this.selecteduserid       = null;

    },
    sDeleteUsers(row)
    {
        //console.log(users);
        this.selecteduser   = row.szusername;
        this.selecteduserid = row.id;
    },
    DeleteUsers()
    {
        //console.log(users);
        this.selecteduser   = row.szusername;
        this.selecteduserid =row.id;
        if(this.selecteduserid == null )
        {
             this.$snotify.error("No User Selected");
             return
        }else
        {

        }
    },
     createNewusers(){
        
        this.users.sz_providerid = this.providerid
        if(this.btnaction == "Save"){
             http()
        .post("/createNewUser/", this.users)
        .then(({ data }) => {
          // console.log(data.message.reason)
          // 
          if (data.success === true) {
            this.$snotify.success(data.message.reason);
            this.getUserList();
            this.$bvModal.hide("newuserform");
            // $emit("close");
          }else if(data.success === false){
            this.$snotify.error(data.message.reason);
          }
        })
        .catch((err) => {
          this.$snotify.error("Unexpected Error Occurred");
          this.$Progress.finish();
        })
        .finally(() => {
          this.loading = false;
          this.$Progress.finish();
        });
        }else {

          if(this.users.id == null || this.users.id == ''){
            this.$snotify.error("Unexpected Error Occurred");
          }
            http()
        .post("/UpdateUserAccount/", this.users)
        .then(({ data }) => {
          // console.log(data.message.reason)
          // 
          if (data.success === true) {
            this.$snotify.success(data.message.reason);
            this.getUserList();
            this.$bvModal.hide("newuserform");
            // $emit("close");
          }else if(data.success === false){
            this.$snotify.error(data.message.reason);
          }
        })
        .catch((err) => {
          this.$snotify.error("Unexpected Error Occurred");
          this.$Progress.finish();
        })
        .finally(() => {
          this.loading = false;
          this.$Progress.finish();
        });
        }
        
     },
     getUserList(){
       this.$Progress.start();
       this.loading = true;
       http()
      .post("/getUserList", { sz_providerid: this.providerid})
      .then(({ data }) => {
        //console.log(data)
        if(data == 'null' || data == null){
          this.tabdata = []
        }else
        {
           this.tabdata = data;
        }
        
        //   console.log(this.tabdata)
      })
      .catch(err => {
        this.$snotify.error("Could not get the list of schools");
        this.$Progress.finish();
      })
      .finally(() => {
        this.loading = false;
      });
     }
    },
    
    computed:{
     ...mapState({
      providerid: state => state.provider.provider_id,
      selecteSchool: state => state.provider.school,
    }),
    filteredRows: {
      get: function () {
        let search = this.search.trim().toLowerCase();

        return this.search.trim() !== ""
          ? this.tabdata.filter((d) => {
              console.log(d.szusername)
              return (
                d.szusername.toLowerCase().indexOf(search) > -1 /*||
                d.sz_contactemail.toLowerCase().indexOf(search) > -1 ||
                d.sz_contactphoneno.toLowerCase().indexOf(search) > -1 ||
                d.sz_contactname.toLowerCase().indexOf(search) > -1*/
              );
            })
          : this.tabdata;
      },
      // setter
      set: function (newValue) {
        this.tabdata = newValue;
      }
    },
    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },
    totalPage: function () {
      return Math.ceil(this.filteredRows.length / this.countOfPage);
    },
    theData() {
      // console.log(this.filteredRows)
      return this.filteredRows.slice(
        this.pageStart,
        this.pageStart + this.countOfPage
      );
     }
    },
    created() {
      var d = new Date();
      this.getUserList();
  }
}
</script>
<style scoped>
    
</style>